import React from "react";
import { useSelector } from "react-redux";


const UserName = props => {
  const userDetails = useSelector(
    store => store.getUserDetailsReducer.userDetails
  );

  return <span>{userDetails.firstName ? ' ' + userDetails.firstName : ' User'} {userDetails.lastName ? ' ' + userDetails.lastName : ' Name'}</span>;
};

export default UserName;